import React from "react";
import PropTypes from "prop-types";

import { caller, agent } from "./Events.module.scss";

const SPEAKERS = { caller, agent };

const SpeechEvent = ({ startTime, endTime, speaker, progressPercent }) => {
  return <div className={SPEAKERS[speaker]}
    style={{ left: `${progressPercent(startTime)}%`, width: `${progressPercent(endTime - startTime)}%` }}
  />;
};

SpeechEvent.propTypes = {
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
  speaker: PropTypes.string.isRequired,
  progressPercent: PropTypes.func.isRequired
};

export default SpeechEvent;
